export const isValidDate = (date: Date) => {
  return date instanceof Date && !isNaN(date.getTime())
}

export const isValidDateString = (dateStr: string): boolean => {
  const [day, month, year] = dateStr.split('/').map(Number)
  const date = new Date(year, month - 1, day)

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  )
}
